export default "__VITE_ASSET__pkTLV8sE__"